import { CATALOG_CODE } from '../../../../shared/constants/catalog-codes';
import { SpecFieldNames } from '../../specification/constants/specification-field-names.enum';

export const catalogToFieldConversion = {
  [CATALOG_CODE.UNLOAD_TYPE]: SpecFieldNames.UNLOAD_TYPE,
  [CATALOG_CODE.PUMP_CAPACITY]: SpecFieldNames.PUMP,
  [CATALOG_CODE.DISCHARGE_TIME]: SpecFieldNames.DISCHARGE_TIME,
  [CATALOG_CODE.TIME_PER_LOAD]: SpecFieldNames.SPACING,
  [CATALOG_CODE.ELEMENT]: SpecFieldNames.APPLICATION,
  [CATALOG_CODE.SLUMP]: SpecFieldNames.SLUMP,
};

export const fieldToCatalogConversion = {
  [SpecFieldNames.UNLOAD_TYPE]: CATALOG_CODE.UNLOAD_TYPE,
  [SpecFieldNames.PUMP]: CATALOG_CODE.PUMP_CAPACITY,
  [SpecFieldNames.DISCHARGE_TIME]: CATALOG_CODE.DISCHARGE_TIME,
  [SpecFieldNames.SPACING]: CATALOG_CODE.TIME_PER_LOAD,
  [SpecFieldNames.APPLICATION]: CATALOG_CODE.ELEMENT,
  [SpecFieldNames.SLUMP]: CATALOG_CODE.SLUMP,
};
